<template>
  <layout-base badge-text="OffSec">
    <slot />
  </layout-base>
</template>
